<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Lettermix" [steps]="this.wordMatrix().length" [progress]="progress()" />

  <rid-mechanic-content>
    <!-- title -->
    <rid-mechanic-title [title]="'Maak zo veel mogelijk woorden'" />

    <!-- assignment -->
    @for (assignment of [assignment()]; track assignment.id) {
      <div class="absolute flex h-full flex-col pt-24">
        <div class="grid grow place-items-center">
          <div class="absolute grid place-items-center gap-4" animate.leave="anim-fade-out">
            <!-- options -->
            <div class="flex gap-2">
              @for (option of assignment.options; track $index) {
                <rid-klank-card-clickable
                  [klank]="option"
                  animate.enter="anim-pop-in"
                  [disabled]="canGoToNext()"
                  [style.animation-delay.ms]="500 + $index * 50"
                  (clicked)="append(option)"
                />
              }
            </div>
            <!-- input -->
            <div class="flex items-center gap-2" animate.enter="wait-500 anim-pop-in">
              <rid-text-input class="min-w-2xl">
                <div class="flex justify-center gap-2">
                  <rid-vertical-spacer><rid-klank-card klank="x" /></rid-vertical-spacer>

                  @for (char of text(); track $index) {
                    <rid-klank-card [klank]="char" animate.enter="anim-pop-in" animate.leave="anim-pop-out" />
                  }
                </div>
              </rid-text-input>
              <div class="flex flex-col gap-4">
                <rid-button appearance="DANGER" keybind="Backspace" [disabled]="text().length === 0" (click)="pop()">
                  <i-backspace class="size-[1lh]" />
                </rid-button>
                <rid-button keybind="Enter" [disabled]="text().length === 0 || seenWords().includes(text().join(''))" (click)="check()">
                  <i-enter class="size-[1lh]" />
                </rid-button>
              </div>
            </div>
          </div>
        </div>

        <!-- answers -->
        <div
          class="relative flex w-2xl flex-wrap justify-center gap-4 rounded-4xl bg-linear-to-b from-black/80 to-black/0 p-8 pb-24 xl:w-6xl"
          animate.enter="wait-500 anim-slide-from-bottom"
          animate.leave="anim-slide-to-bottom"
        >
          @for (answer of assignment.answers; track $index) {
            <rid-lettermix-word
              [word]="answer.word"
              [appearance]="answer.appearance"
              animate.enter="anim-pop-in"
              [style.animation-delay.ms]="750 + $index * 50"
            />
          }

          <rid-button
            class="absolute right-4 bottom-4"
            content="Laat antwoorden zien"
            appearance="NEUTRAL"
            variant="SECONDARY"
            size="SMALL"
            [disabled]="canGoToNext()"
            (click)="reveal()"
          />
        </div>
      </div>
    }

    <!-- button -->
    @if (canGoToNext()) {
      <rid-bottom-button content="Volgende" animate.enter="wait-500" (clicked)="next()" />
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
